import { render, staticRenderFns } from "./H5Dialog.vue?vue&type=template&id=776fac32&scoped=true&"
import script from "./H5Dialog.vue?vue&type=script&lang=js&"
export * from "./H5Dialog.vue?vue&type=script&lang=js&"
import style0 from "./H5Dialog.vue?vue&type=style&index=0&id=776fac32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776fac32",
  null
  
)

export default component.exports